// @ts-strict-ignore
import {Component, Injector, OnInit} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import Enumerable from "linq";
import {PlayerMapping, PlayerType, TrainingRoom} from "@models";
import {SimEnumExtendedService, NotificationService, SimSystemExtendedService} from "@services";
import {SimTrainingRoomService} from "@services";
import {Translations} from "@translations";

export interface DialogData_RoomMediaScreenSelectionDialogInput extends MatDialogDataBaseInput {
	trainingRoom: TrainingRoom;
}

export interface DialogData_RoomMediaScreenSelectionDialogOutput extends MatDialogDataBaseOutput {
	updatedTrainingRoom: TrainingRoom;
}

@Component({
	selector: "sim-room-media-screen-selection-dialog",
	templateUrl: "./room-media-screen-selection-dialog.component.html",
	styleUrls: ["./room-media-screen-selection-dialog.component.scss"],
	standalone: false,
})
export class RoomMediaScreenSelectionDialogComponent extends BasicMaterialDialog<
	RoomMediaScreenSelectionDialogComponent,
	DialogData_RoomMediaScreenSelectionDialogInput,
	DialogData_RoomMediaScreenSelectionDialogOutput
> {
	T = Translations;
	public selectedPlayerId: string = null;

	public playerList: Enumerable.IDictionary<string, PlayerMapping> = null;

	constructor(
		_injector: Injector,
		private _simSystemService: SimSystemExtendedService,
		private _simEnumService: SimEnumExtendedService,
		private _simTrainingRoomService: SimTrainingRoomService,
		private _simNotificationService: NotificationService,
	) {
		super(_injector);
	}

	public ngOnInit() {
		super.ngOnInit();

		this._simSystemService.getPlayers().then((result) => {
			this.playerList = Enumerable.from(result)
				.where((player) => this._simEnumService.containsFlags(player.type, PlayerType.MediaScreen)) // (player.type & PlayerType.Debriefing) === PlayerType.Debriefing
				.toDictionary(
					(player) => player.id,
					(player) => player,
				);
		});
	}

	ok() {
		this.selectedPlayerId = null;
		this.close({action: "ok", updatedTrainingRoom: this.data.trainingRoom});
	}

	public getPlayerName(playerId: string) {
		if (this.playerList.contains(playerId)) {
			// return "(".concat(this.audioInputChannelDictionary[channel].channel, ")",, this.audioInputChannelDictionary[channel].name);
			return this.playerList.get(playerId).name;
		} else {
			return `Player not defined: ${playerId}`;
		}
	}

	public addPlayer(playerId: string, playerIds: string[]) {
		if (playerIds.indexOf(playerId) < 0) {
			playerIds.push(playerId);
		}
	}

	public removePlayer(playerId: string, playerIds: string[]) {
		playerIds.splice(playerIds.indexOf(playerId), 1);
	}

	public filteredPlayerList() {
		return this.playerList.toEnumerable().where((player) => !this.data.trainingRoom.mediaScreenDeviceIds.includes(player.value.id));
	}
}
